import { render, staticRenderFns } from "./SummaryDb.vue?vue&type=template&id=8ec25402&scoped=true"
import script from "./SummaryDb.vue?vue&type=script&lang=js"
export * from "./SummaryDb.vue?vue&type=script&lang=js"
import style0 from "./SummaryDb.vue?vue&type=style&index=0&id=8ec25402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec25402",
  null
  
)

export default component.exports